import React, { useEffect, useState, useRef } from 'react'
import Api from '../api.js';
import { Link, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';

export default function Tabla({ info, noQueries = false, noFilter = false, preSearch = false, filter = [], status = [], openVisor = false, forceRender, style = [], alwaysHidden = false }) {
    let api = new Api();
    let infoUsuario = useSelector((state) => state.infoUsuario.value);
    let infoGeneral = useSelector((state) => state.infoGeneral.value);
    let location = useLocation();

    let [tableInfo, setTableInfo] = useState([]);
    let [pages, setPages] = useState(1);
    let [sort, setSort] = useState({ by: "", order: "" });
    let page = useRef(1);
    let searchParameter = useRef("");
    let listStatus = useRef(1);
    const [selectedFilter, setSelectedFilter] = useState(null);

    const [searchValue, setSearchValue] = useState('')
    const filtroSeleccionado = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (page.current) page.current.value = 1;
            listar();
        }, 500);

        return () => clearTimeout(timer);
    }, [searchValue]);

    useEffect(() => {
        if (infoUsuario.token !== null) {
            listar();
        }
    }, [infoUsuario, sort, forceRender, preSearch]);


    async function listar() {
        console.log("EL presearch es " + preSearch);

        if (preSearch === "noBuscar") {
            return;
        }

        if (noQueries) {
            const resp = await api.get(info.endpoint, infoUsuario.token);

            if (!resp.error) {
                if (info.infoInKey) {
                    setTableInfo(resp.info[info.infoInKey]);
                } else {
                    setTableInfo(resp.info);
                }

                setPages(resp.pages === 0 ? 1 : resp.pages);
            }

            return;
        }

        let statusValue = null;

        if (!noFilter) {
            if (filtroSeleccionado.current) {
                statusValue = filtroSeleccionado.current.value;
            } else if (listStatus.current) {
                statusValue = listStatus.current.value;
            } else if (status && status.length > 0) {
                statusValue = status;
            }
        } else {
            if (status && status.length > 0) {
                statusValue = status;
            }
        }

        const currentSearch =
            searchValue && searchValue.trim() !== ""
                ? searchValue
                : searchParameter.current?.value || "";

        if (currentSearch !== "" && currentSearch.length < 3) {
            return;
        }

        const endpoint2 = buildEndpoint({
            pageValue: page.current?.value || 1,
            statusValue,
            searchValueParam: currentSearch,
        });

        console.log("LISTAR:", endpoint2);

        const resp = await api.get(endpoint2, infoUsuario.token);

        if (!resp.error) {
            if (info.infoInKey) {
                setTableInfo(resp.info[info.infoInKey]);
            } else {
                setTableInfo(resp.info);
            }

            if (resp.pages === 0) {
                setPages(1);
            } else {
                setPages(resp.pages);
            }
        }
    }

    function buildEndpoint({
        pageValue = 1,
        statusValue = null,
        searchValueParam = "",
    }) {
        let endpointBase = info.endpoint;
        let filter = {};

        // Si el endpoint original ya trae un filter, lo recuperamos
        const existingFilterMatch = endpointBase.match(/[?&]filter=([^&]+)/);

        if (existingFilterMatch) {
            try {
                const existingFilter = JSON.parse(
                    decodeURIComponent(existingFilterMatch[1])
                );
                filter = { ...existingFilter };
            } catch (error) {
                console.warn("No se pudo parsear el filter existente:", error);
            }
        }

        // Limpiar query params previos
        endpointBase = endpointBase.replace(/([?&])page=\d+&?/, "$1");
        endpointBase = endpointBase.replace(/([?&])search=[^&]*&?/, "$1");
        endpointBase = endpointBase.replace(/([?&])filter=([^&]+)&?/, "$1");
        endpointBase = endpointBase.replace(/([?&])order=([^&]+)&?/, "$1");
        endpointBase = endpointBase.replace(/[?&]$/, "");

        // Mantener patientId si viene desde preSearch
        if (
            preSearch !== false &&
            preSearch !== null &&
            preSearch !== undefined &&
            preSearch !== "noBuscar"
        ) {
            filter.patientId = Number(preSearch);
        }

        // Agregar statusId si llega statusValue
        if (
            statusValue !== null &&
            statusValue !== undefined &&
            statusValue !== "" &&
            !(Array.isArray(statusValue) && statusValue.length === 0) &&
            statusValue !== "all"
        ) {
            if (Array.isArray(statusValue)) {
                filter.statusId = statusValue.map(Number);
            } else {
                filter.statusId = parseInt(statusValue);
            }
        } else {
            delete filter.statusId;
        }

        let query = `page=${pageValue}`;

        if (searchValueParam && searchValueParam.trim() !== "") {
            query += `&search=${encodeURIComponent(searchValueParam.trim())}`;
        }

        if (Object.keys(filter).length > 0) {
            query += `&filter=${encodeURIComponent(JSON.stringify(filter))}`;
        }

        if (sort.by !== "") {
            query += `&order=${encodeURIComponent(
                JSON.stringify([[sort.by, sort.order]])
            )}`;
        }

        const connector = endpointBase.includes("?") ? "&" : "?";
        return endpointBase + connector + query;
    }

    async function filtrar(val = null) {
        if (val) {
            filtroSeleccionado.current = val;
        }

        const statusValue = filtroSeleccionado.current
            ? filtroSeleccionado.current.value
            : null;

        const endpoint2 = buildEndpoint({
            pageValue: page.current?.value || 1,
            statusValue,
            searchValueParam: searchValue,
        });

        console.log("FILTRAR:", endpoint2);

        const resp = await api.get(endpoint2, infoUsuario.token);

        if (!resp.error) {
            if (info.infoInKey) {
                setTableInfo(resp.info[info.infoInKey]);
            } else {
                setTableInfo(resp.info);
            }

            setPages(resp.pages === 0 ? 1 : resp.pages);
        }
    }

    const createUrl = (text, info) => {
        let result = [];
        let currentText = "";
        let inVariable = false;

        for (let i = 0; i < text.length; i++) {
            let char = text[i];
            if (char === "$") {
                if (inVariable) {
                    result.push({ type: "variable", value: currentText });
                    currentText = "";
                    inVariable = false;
                } else {
                    result.push({ type: "text", value: currentText });
                    currentText = "";
                    inVariable = true;
                }
            } else {
                currentText += char;
            }
        }

        if (currentText) {
            result.push({ type: inVariable ? "variable" : "text", value: currentText });
        }

        result = result.map((section) => {
            if (section.type == "text") {
                return section.value;
            } else {
                return info[section.value];
            }
        }).join("");

        return result;
    }

    async function toggleStatus(event, id, url) {
        var t = window.confirm("Esta seguro que desea cambiar el estado?");

        if (t !== true) {
            return;
        }
        let data;
        data = { statusId: parseInt(event.target.value) }

        var resp = await api.put(url + "/" + id, data, infoUsuario.token);

        if (!resp.error) {
            listar();
        }
    }

    async function sortFunc(sortBy) {
        if (sort.by == sortBy) {
            if (sort.order == "ASC") {
                setSort({ by: sortBy, order: "DESC" })
            } else {
                setSort({ by: sortBy, order: "ASC" })
            }
        } else {
            setSort({ by: sortBy, order: "ASC" })
        }
    }

    let controls = "pageSubHeading";
    if (noQueries || alwaysHidden) {
        controls = "pageSubHeadingHidden";
    }

    let filterVisible = "none";
    if (filter.length !== 0) {
        filterVisible = "flex";
    }
    let [isSearching, setIsSearching] = useState(false);
    if (preSearch) {
        if (!isSearching) {
            //searchParameter.current.value = preSearch;
            filter = "documentType";
            listar();
            setIsSearching(true);
        }
    }
    return (
        <>
            <div className={controls} style={style}>
                <input type="search" className="searchInput" placeholder="Buscar" ref={searchParameter} onChange={(e) => { setSearchValue(e.target.value); if (page.current) page.current.value = 1; }} value={searchValue} />
                <Select styles={{ container: (base) => ({ ...base, width: "40%", display: filterVisible }) }} value={selectedFilter} onChange={(val) => { setSelectedFilter(val); if (page.current) page.current.value = 1; filtrar(val); }} options={filter} />

                <div>
                    <span className="pageSelectorText">Página</span>
                    <select
                        className="pageSelector"
                        ref={page}
                        onChange={() => filtrar()}
                    >
                        {Array.from(Array(pages), (e, i) => (
                            <option key={i + 1} value={i + 1}>
                                {i + 1}
                            </option>
                        ))}
                    </select>{" "}
                    de {pages}
                </div>
            </div>
            <div className="tableContainer" style={style}>
                <table>
                    <thead>
                        <tr>
                            {info.titulos.map((titulo, index) => {
                                if (titulo.name == "status") {
                                    return <th key={index}><select className="statusSelect" ref={listStatus} onChange={listar}>{infoGeneral.status.map((status, index2) => { return <option key={index2} value={status.id}>{status.name}</option> })}</select></th>;
                                } else {
                                    if (titulo.name) {
                                        return <th key={index} onClick={() => { sortFunc(titulo.name) }}>{titulo.texto}</th>
                                    } else {
                                        return <th key={index}>{titulo.texto}</th>
                                    }

                                }
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {tableInfo.map((row, index) => {
                            return <tr key={index}>
                                {info.columnas.map((col, index) => {
                                    if (col["type"] == "text") {
                                        let v;
                                        if (col["nested"]) {
                                            v = row[col["prop"]][col.nested];
                                        } else {
                                            v = row[col["prop"]];
                                        }

                                        if (openVisor && col["openVisor"]) {
                                            if (col["format"]) {
                                                return <td key={index} onClick={() => { openVisor(row["fileMimetype"], row["file"], row["id"]) }}>{col["format"](v)}</td>
                                            } else {
                                                return <td key={index} onClick={() => { openVisor(row["fileMimetype"], row["file"], row["id"]) }}>{v}</td>
                                            }
                                        } else {
                                            if (col["format"]) {
                                                if (col["prop"] == "") {
                                                    v = row;
                                                }
                                                return <td key={index}>{col["format"](v)}</td>
                                            } else {
                                                return <td key={index}>{v}</td>
                                            }
                                        }

                                    }

                                    if (col["type"] == "boldText") {

                                        let v;
                                        if (col["nested"]) {
                                            v = row[col["prop"]][col.nested];
                                        } else {
                                            v = row[col["prop"]];
                                        }

                                        if (openVisor && col["openVisor"]) {
                                            if (col["format"]) {
                                                return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index} onClick={() => { openVisor(row["fileMimetype"], row["file"], row["id"], row) }}>{col["format"](v)}</td>
                                            } else {
                                                return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index} onClick={() => { openVisor(row["fileMimetype"], row["file"], row["id"], row) }}>{v}</td>
                                            }
                                        } else {
                                            if (col["format"]) {
                                                return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index}>{col["format"](v)}</td>
                                            } else {
                                                return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index}>{v}</td>
                                            }
                                        }

                                    }
                                    if (col["type"] == "func") {

                                        let v;
                                        if (col["nested"]) {
                                            v = row[col["prop"]][col.nested];
                                        } else {
                                            v = row[col["prop"]];
                                        }

                                        if (col["format"]) {
                                            return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index} onClick={() => { col["func"](v); }}>{col["placeholder"]}</td>
                                        } else {
                                            return <td style={{ fontWeight: "bold", cursor: "pointer" }} key={index} onClick={() => { col["func"](v); }}>{col["placeholder"]}</td>
                                        }

                                    }

                                    if (col["type"] == "link") {
                                        let v;
                                        if (col["nested"]) {
                                            v = row[col["prop"]][col.nested];
                                        } else if (col.placeholder) {
                                            v = col.placeholder;
                                        } else {
                                            v = row[col["prop"]];
                                        }
                                        // console.log(col, col["urlProp"], col["customUrl"]);

                                        if (col["urlProp"]) {
                                            if (col["format"]) {
                                                return <td key={index}><a href={row[col["urlProp"]]} target="_blank">{col["format"](v)}</a></td>;
                                            } else {
                                                if (row[col["urlProp"]].includes(`["`)) {
                                                    return <td key={index}><a href={"#"} target="_blank" onClick={() => {
                                                        var downloadUrls = JSON.parse(row[col["urlProp"]]);
                                                        downloadUrls.forEach(function (value, idx) {
                                                            const response = {
                                                                file: value,
                                                            };
                                                            setTimeout(() => {
                                                                window.location.href = response.file;
                                                            }, idx * 100)
                                                        })
                                                    }}>{v}</a></td>;
                                                }
                                                return <td key={index}><a href={row[col["urlProp"]]} target="_blank">{v}</a></td>;
                                            }
                                        } else if (col["customUrl"]) {
                                            const formattedUrl = col["format"] ? col["format"](row) : "#";
                                            const textValue = typeof col["text"] === "function" ? col["text"](row) : row[col["text"]] || "Sin datos";

                                            return <td key={index}><a href={formattedUrl} target={col["target"] || "_blank"}>{textValue}</a></td>;
                                        } else {
                                            let url = createUrl(col["url"], row);
                                            if (col["format"]) {
                                                return <td key={index}><Link to={url}>{col["format"](v)}</Link></td>
                                            } else {
                                                return <td key={index}><Link to={url}>{v}</Link></td>
                                            }
                                        }



                                    }

                                    if (col["type"] == "status") {
                                        let limit = 2;
                                        if (col["statusOrder"]) {
                                            limit = 4;
                                        }
                                        const id = col['customId'] ? row[col['customId']] : row["id"];
                                        const valueSelected = col['nested'] ? row[col['nested']]['statusId'] : row["statusId"];
                                        return (
                                            <td key={index}>
                                                <select className="statusSelect" value={valueSelected} onChange={(e) => { toggleStatus(e, id, col["url"]); }}>
                                                    {infoGeneral.status.map((status, index2) => {
                                                        if (status.id <= limit) {
                                                            return <option key={index2} value={status.id}>{status.name}</option>
                                                        }
                                                    })}
                                                </select>
                                            </td>
                                        );
                                    }

                                })}
                            </tr>;
                        })}
                    </tbody>
                </table>
            </div>
        </>
    )
}

Tabla.propTypes = {
    info: PropTypes.object.isRequired,
    forceRender: PropTypes.number.isRequired
};